export const setMasiveUploadParams = (query, current) => {
  let massiveUploadName = 'Massive Upload';
  let date = new Date().toISOString().split('T')[0];
  const {
    regionId,
    subRegionId,
    territoryId,
    clientId,
    family,
    lineId,
    year,
    productId,
    policyTypeId,
  } = query;
  let params = { year, name: `ACUERDO ${date}`, lineId };

  switch (current) {
    case 'regionId':
      massiveUploadName = 'region';
      params = { ...params, regionId };
      break;
    case 'lineId':
      massiveUploadName = 'businessLine';
      params = { ...params, regionId, lineId };
      break;
    case 'subRegionId':
      massiveUploadName = 'subRegion';
      params = { ...params, regionId, clientId, subRegionId };
      break;
    case 'territoryId':
      massiveUploadName = 'territory';
      params = { ...params, regionId, territoryId };
      break;
    case 'family':
      massiveUploadName = 'family';
      params = { ...params, clientId, family, territoryId, policyTypeId };
      break;
    case 'clientId':
      massiveUploadName = 'client';
      params = { ...params, clientId, territoryId };
      break;
    case 'productId':
      massiveUploadName = 'product';
      params = { ...params, clientId, productId, territoryId, policyTypeId };
      break;

    default:
      break;
  }
  return { params, massiveUploadName };
};
